var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.navigateTo}},[_c('img',{attrs:{"src":_vm.isActive ? _vm.iconImgActive : _vm.iconImg,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }